import { browser } from "$app/environment"
import { init, register } from "svelte-i18n"

const defaultLocale = "en"
register(defaultLocale, () => import("./locales/en"))

init({
  fallbackLocale: defaultLocale,
  initialLocale: browser ? window.navigator.language : defaultLocale,
})
